import { controls } from "../../controls";

const rp902 = {
  label: "Comparative",
  pageLabel: "Comparative",
  starting: true,
  url: "rp902",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [


    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", width: "col-sm-4", isReadOnly: true, defaultValue: "assigned_branch" }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-6" }),

    ...controls.displayText({ tab: "Modal", label: "General Ledger", width: "col-sm-2" }),
    ...controls.GL({ tab: "Modal", width: "col-sm-4" }),
    ...controls.showData({ tab: "Modal", data: "gl_code_display", name: "gl_code_display", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "Date 1", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-4", onLeave: [{ action: '1 years ago', target: "oneyeardate" }, { action: '2 years ago', target: "twoyeardate" }, { action: '3 years ago', target: "threeyeardate" }] }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "Date 2", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "oneyeardate", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "Date 3", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "twoyeardate", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "Date 4", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "threeyeardate", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    //   {
    //     widths: "col-sm-6",
    //     tab: "filter",
    //     title: "Personal Info icon-aadhaarScanner",
    //     subComponents: [

    //       ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2"}),
    //       ...controls.branch({ tab: "filter", width: "col-sm-4" }),
    //       ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-6" }),

    //       ...controls.displayText({tab:"Modal",label: "General Ledger",width:"col-sm-2"}),
    //       ...controls.GL({tab: "Modal", width: "col-sm-4"}),
    //       ...controls.showData({tab:"Modal",data: "gl_code_display", name: "gl_code_display",width:"col-sm-6"}),

    //       ...controls.displayText({tab: "filter",label: "Date 1",star:true,width:"col-sm-2 "}),
    //       ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-4", onLeave: [{ action: '1 years ago', target: "oneyeardate" }, { action: '2 years ago', target: "twoyeardate" }, { action: '3 years ago', target: "threeyeardate" }] }),
    //       ...controls.displayText({tab: "filter",label: "",width:"col-sm-6 "}),

    //       ...controls.displayText({tab: "filter",label: "Date 2",width:"col-sm-2 "}),
    //       ...controls.magicDate({tab: "filter",name:"oneyeardate",width:"col-sm-4"}),
    //       ...controls.displayText({tab: "filter",label: "",width:"col-sm-6 "}),

    //       ...controls.displayText({tab: "filter",label: "Date 3",width:"col-sm-2 "}),
    //       ...controls.magicDate({tab: "filter",name:"twoyeardate",width:"col-sm-4"}),
    //       ...controls.displayText({tab: "filter",label: "",width:"col-sm-6 "}),

    //       ...controls.displayText({tab: "filter",label: "Date 4",width:"col-sm-2 "}),
    //       ...controls.magicDate({tab: "filter",name:"threeyeardate",width:"col-sm-4"}),
    //       ...controls.displayText({tab: "filter",label: "",width:"col-sm-6 "}),
    //     ]
    //   },
    //   {
    //     widths: "col-sm-6",
    //     tab: "filter",
    //     title: "Graph showing trends",
    //     subComponents: [
    //     ]
    //   }
    // ],




    //form: [
    //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
    //  ...controls.text({ name: "crop_type", isRequired: true }),
    //  ...controls.displayText({ width: "col-sm-3" }),

    //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
    //  ...controls.text({ name: "crop_type_display", isRequired: true }),
    //  ...controls.displayText({ width: "col-sm-3" }),

  ],
  form: [],

  history: {
    perPage: 10,
    reportHeader: "Comparative GL statement	",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "GL",
        accessor: "gl",
        rwidth: 200
      },
      {
        Header: "Date1",
        accessor: "date1amt",
        type: "currency",
      },
      // {
      //   Header:"%",
      //   accessor:"",
      //   type:"",
      //   rwidth:10
      // },
      {
        Header: "Date2",
        accessor: "date2amt",
        type: "currency",
      },
      // {
      //   Header:"0.00",
      //   accessor:"",
      //   type:"",
      //   rwidth:10
      // },
      {
        Header: "Date3",
        accessor: "date3amt",
        type: "currency",
      },
      // {
      //   Header:"0.00",
      //   accessor:"",
      //   type:"",
      //   rwidth:10
      // },
      {
        Header: "Date4",
        accessor: "date4amt",
        type: "currency",
      },
      // {
      //     Header:"-0.03",
      //     accessor:"-0.03",
      //     rwidth:"*"
      // }

    ]
  }
};

export default rp902;